<div [ngClass]="{ full: full, extern: extern }">
  @if (full) {
    <!--Popup admin (see all notes)-->
    <!--Header-->
    <div class="header flex align-items-center text-xs mb-4">
      <i class="pi pi-pencil" [style.visibility]="'hidden'"></i>
      <div class="text-gray-400 date date2">Timestamp</div>
      <div class="text-blue-400 ml-2 date datePublic">Date publique</div>
      <div class="type">Type</div>
      <div class="statusRef">Statut personne</div>
      <div class="text">Note</div>
    </div>
  }
  @if (full || extern) {
    @for (note of notes; track note.date) {
      <div class="flex text-xs note mb-2">
        <i class="pi pi-pencil" (click)="openUpdateNote(note)"></i>
        <div class="text-gray-400 date date2" [title]="note.date | date: 'DD/MM/YYYY à HH:mm:ss'">
          {{ note.date | date: "DD/MM/YYYY à HH:mm" }}
        </div>
        <div class="text-blue-400 ml-2 date datePublic" [title]="note.datePublic | date: 'DD/MM/YYYY à HH:mm:ss'">
          {{ note.datePublic | date: "DD/MM/YYYY" }}
        </div>
        <div class="type" [ngClass]="note.type">{{ mapTypeLabel[note.type] }}</div>
        <div class="statusRef" [ngClass]="note.type" *ngIf="note.statusRef || full">
          {{ mapStatusPersons[note.statusRef?.id || ""] }}
          <span *ngIf="extern">&nbsp;-&nbsp;</span>
        </div>
        <div class="text" [ngClass]="note.type">{{ note.text }}</div>
      </div>
    }
  } @else {
    <!--Screen "Gérer la comm' externe"-->
    <div class="flex flex-column justify-content-center" style="height: 46px">
      @for (note of notesTwoLines; track note.date; let i = $index) {
        <div class="flex text-xs note align-items-center">
          <div class="text-gray-400 date date2">
            <span [title]="note.datePublic | date: 'DD/MM/YYYY à HH:mm:ss'" class="text-blue-400">
              {{ note.datePublic | date: "DD/MM/YYYY à HH:mm" }}</span
            >
            <span [title]="note.date | date: 'DD/MM/YYYY à HH:mm:ss'">
              {{ note.date | date: "DD/MM/YYYY à HH:mm" }}</span
            >
          </div>
          <!--      <div class="text-blue-400 ml-2 date datePublic" [title]="note.datePublic | date : 'DD/MM/YYYY à HH:mm:ss'">-->
          <!--        {{ note.datePublic | date : "DD/MM/YYYY" }}-->
          <!--      </div>-->
          <p-badge *ngIf="countNotesPrio && i === 0" class="badge-prio" [value]="countNotesPrio" />
          <div class="text ellipsis" [ngClass]="note.type" [title]="note.text">{{ note.text }}</div>
        </div>
      }
    </div>
  }
</div>
